module.exports = ".content.p-24 mat-form-field {\n  margin-bottom: 25px; }\n"